module.exports = __webpack_public_path__ + "static/media/beach.fa120fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beach.png
// module id = 1683
// module chunks = 0